<template>
    <div class="text-muted font-size-sm">
        {{ __('orders.states_included_list') }}
        <div class="text-uppercase">
            {{ orderStates.map(state => __('orders.states.' + state)).join(', ') }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        orderStates: Array
    }
}
</script>
